// extracted by mini-css-extract-plugin
export default {"solutionWrapper":"style_solutionWrapper__l0pMm"};